import { render, staticRenderFns } from "./BucketField.vue?vue&type=template&id=70bed0e2"
import script from "./BucketField.vue?vue&type=script&lang=js"
export * from "./BucketField.vue?vue&type=script&lang=js"
import style0 from "./BucketField.vue?vue&type=style&index=0&id=70bed0e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports